import { toast } from 'sonner';

/**
 * Zaślepka akcji, których kontrakt paczki nie wyraża.
 *
 * Zostały dwie rzeczy: dodanie uczestnika do rezerwacji (osobna operacja
 * domenowa, a nie pozycja rachunku — paczka nie ma dla niej typu pozycji) oraz
 * wiersze, których żaden typ pozycji nie obejmuje (`ref === null`): zniżki
 * rachunku i pola tylko do odczytu. Klik w taki przycisk mówi wprost, że akcja
 * nie działa, zamiast po cichu nic nie robić.
 */
export const notifyActionUnavailable = (action: string): void => {
  toast.info('Ta akcja nie jest jeszcze dostępna', {
    description: `${action} — do zrobienia po podpięciu API paczek zmian.`,
  });
};
